var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup2377(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.294,
    height: 100,
    viewBox: "0 0 114.294 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2377",
    "data-name": "Group 2377",
    transform: "translate(-1748 -1738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M7,54.944a7.13,7.13,0,1,1,7.13,7.13A7.13,7.13,0,0,1,7,54.944Zm.7-42.819a6.453,6.453,0,1,1,12.835,0l-2.5,25.007a3.936,3.936,0,0,1-7.844,0Z",
    transform: "translate(1790.998 1761.664)",
    fill: "#f2163e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M64.149,5.051a8.071,8.071,0,0,0-14,0L1.177,88.378a8.334,8.334,0,0,0,7,12.62h97.94a8.333,8.333,0,0,0,7-12.62Z",
    transform: "translate(1748 1737.002)",
    fill: "#f2163e",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M56.692,8.265a.957.957,0,0,1,.907,0,1.043,1.043,0,0,1,.386.407L106.959,92a1.248,1.248,0,0,1,.014,1.307,1.164,1.164,0,0,1-.386.429.828.828,0,0,1-.471.121H8.183a.821.821,0,0,1-.471-.121,1.164,1.164,0,0,1-.386-.429A1.257,1.257,0,0,1,7.34,92L56.307,8.672a1.05,1.05,0,0,1,.386-.407Zm7.456-3.214a8.071,8.071,0,0,0-14,0L1.177,88.378a8.334,8.334,0,0,0,7,12.62h97.94a8.333,8.333,0,0,0,7-12.62Z",
    transform: "translate(1748 1737.002)",
    fill: "#f2163e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2377);
export default __webpack_public_path__ + "static/media/Group 2377.47e782a6.svg";
export { ForwardRef as ReactComponent };